import { Modifier } from './Modifier';
/**
 * Adds a closing point if it doesn't exist
 *
 * @category Modifiers
 * @class Close
 * @extends {Modifier}
 */
class Close extends Modifier {
    constructor() {
        super();
    }
    apply(buffer, bClosed, shape) {
        return Close.call(buffer);
    }
    static call(buffer) {
        const len = buffer.length;
        if (Close.isClosed(buffer))
            return buffer;
        const result = new Float32Array(len + 2);
        result.set(buffer, 0);
        result[len] = result[0];
        result[len + 1] = result[1];
        return result;
    }
    static isClosed(buffer) {
        const len = buffer.length;
        return buffer[0] === buffer[len - 2] && buffer[1] === buffer[len - 1];
    }
}
export { Close };
//# sourceMappingURL=Close.js.map